import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const getReferringProviders = async () => {
  const url = `${endpoints.physicians.referringProviders}`;
  const { data } = await api.get(url);
  return data;
};

export const createReferringProvider = async (payload) => {
  const response = await api.post(
    endpoints.physicians.referringProviders,
    payload
  );
  return response;
};

export const updateReferringProvider = async (id, payload) => {
  const url = interpolate(endpoints.physicians.referringProvidersById, { id });
  const response = await api.patch(url, payload);
  return response;
};

export const deleteReferringProvider = async (id) => {
  const url = interpolate(endpoints.physicians.referringProvidersById, { id });
  const response = await api.delete(url);
  return response;
};
